export enum DisplayCrossSellModal {
  NAME = 'cross_sell_pdp_experiment',
  NO_CROSS_SELL = 'no_cross_sell',
  DIRECT_TO_CART_ON_ADD_TO_BASKET = 'direct_to_cart_on_add_to_basket',
  DIRECT_TO_CART_ON_CONTINUE_TO_BASKET = 'direct_to_cart_on_continue_to_basket',
}

export enum Loop54SearchAlgorithm {
  NAME = 'optimise_search_algorithm_experiment',
  CONTROL = 'control',
  VARIANT = 'variant',
}

export enum SimilarProductsShelf {
  NAME = 'similar_products_shelf_experiment',
  CONTROL = 'control',
  VARIANT = 'variant',
}

export enum PDPDeliveryTacticalImprovements {
  NAME = 'pdp_delivery_tactical_improvements_experiment',
  CONTROL = 'control',
  DISPLAY_DELIVERY_PROVIDERS = 'display_delivery_providers',
}
